@if (!ticketNumber()) {
<div mat-dialog-title>
  @switch (type()) {
  @case ('regularPayment') {
  <ng-container i18n>Record payment</ng-container>
  }
  @case ('additionalPayment') {
  <ng-container i18n>Reduce term/payment</ng-container>
  }
  @case ('prePayment') {
  <ng-container i18n>Pre-pay</ng-container>
  }
  }
</div>
}
<form id="form" [formGroup]="form" (ngSubmit)="submit()" mat-dialog-content class="ft-payment ft-content px-4 pb-1"
  [ngClass]="ticketNumber() ? 'ft-content--finished' : null">
  @if (
  type() !== 'prePayment' ||
  (type() === 'prePayment' &&
  (totalAmount() || 0) > 0 &&
  prePaymentCalculate())
  ) {
  <div class="ft-card mb-3">
    <div class="ft-card__body text-center">
      <div>
        <div class="ft-icon ft-icon--lead ft-icon--3">
          <svg viewBox="0 0 24 24" style="
                width: 1em;
                height: 1em;
                vertical-align: middle;
                fill: currentColor;
                display: inline-block;
                font-size: 2rem;
              ">
            <path stroke="currentColor" stroke-width="2" d="M19.5 6.5l-10 10-5-5" fill="none" />
          </svg>
        </div>
      </div>
      <div class="ft-data-field">
        @if (!ticketNumber()) {
        @if (type() === 'prePayment') {
        <div class="ft-data-field__value" style="font-size: var(--ft-display-font-size-lg)">
          {{ totalAmount() | number }}
          <span class="ft-suffix ft-suffix--sm">{{ currencyId() }}</span>
        </div>
        <div class="ft-data-field__label" i18n>Total amount</div>
        } @else {
        <div class="ft-data-field__value" style="font-size: var(--ft-display-font-size-lg)">
          {{ pendingAmount() | number }}
          <span class="ft-suffix ft-suffix--sm">{{ currencyId() }}</span>
        </div>
              <div class="ft-data-field__label" i18n>Amount pending payment</div>
        }
        } @else {
        <div class="ft-data-field__value" style="font-size: var(--ft-display-font-size-lg)">
          {{ form.get('amount')?.value | number }}
          <span class="ft-suffix ft-suffix--sm">{{ currencyId() }}</span>
        </div>
        <div class="ft-data-field__label" i18n>Amount paid</div>
        }
      </div>
      @if (ticketNumber()) {
          <div class="mt-4 fs-6 text-success" i18n>Payment registered successfully</div>
      }
      <div class="ft-info">
        <hr class="my-3" />
        <div class="ft-grid ft-grid--c-2">
          <div class="ft-data-field">
            <div class="ft-data-field__value">{{ ticketNumber() }}</div>
            <div class="ft-data-field__label" i18n>Receipt #</div>
          </div>
          <div class="ft-data-field">
            <div class="ft-data-field__value">
              {{ form.get('paymentDate')?.value | date: 'dd/MM/yyyy' }}
            </div>
            <div class="ft-data-field__label" i18n>Date</div>
          </div>
        </div>
      </div>
    </div>
    <div class="ft-payment__brand">
      <img src="images/logo-meprestas.svg" alt="Logo MePrestas" />
    </div>
  </div>
  }
  <div class="ft-form ft-grid ft-grid--cols2 ft-grid--rg-1"
    [ngClass]="form.get('amount')?.invalid ? 'ft-grid--rg-3' : 'ft-grid--rg-1'">
    <div>
      @if (type() === 'prePayment') {
      <small class="text-muted" i18n>Pre-cancellation date</small>
      } @else {
      <small class="text-muted" i18n>Date</small>
      }
      <mat-form-field class="ft-form-field--nolabel w-100">
        <input matInput [matDatepicker]="datePicker" formControlName="paymentDate" [min]="minDate()" [max]="maxDate()"
          readonly (click)="datePicker.open()" />
        <mat-hint>{{ appService.dateFormatHint() }}</mat-hint>
        <mat-datepicker-toggle matIconSuffix [for]="datePicker"></mat-datepicker-toggle>
        <mat-datepicker touchUi #datePicker></mat-datepicker>
        @if (form.get('paymentDate')?.invalid) {
        <mat-error>{{
          appService.getErrorMessage(form.get('paymentDate'))
          }}</mat-error>
        }
      </mat-form-field>
    </div>
    @if (['regularPayment', 'additionalPayment'].includes(type())) {
    <div>
      <small class="text-muted" i18n>Amount</small>
      <mat-form-field class="ft-form-field--nolabel w-100">
        <input type="number" matInput formControlName="amount" class="text-end" />
        <span matSuffix>{{ currencyId() }}</span>
        @if (form.get('amount')?.invalid) {
        <mat-error>{{
          appService.getErrorMessage(form.get('amount'), {
          pattern: messageCommaNotAllowed()
          })
          }}</mat-error>
        }
      </mat-form-field>
    </div>
    }
    @if (type() === 'additionalPayment') {
    <div class="ft-cs-2">
      <small class="text-muted" i18n>Type of advance payment</small>
      <mat-form-field class="ft-form-field--nolabel w-100">
        <mat-select formControlName="additionalPaymentType">
          <mat-select-trigger>
            {{ form.get('additionalPaymentType')?.value.label }}
          </mat-select-trigger>
          @for (
          additionalPaymentType of additionalPaymentTypes();
          track additionalPaymentType.value
          ) {
          <mat-option [value]="additionalPaymentType">{{
            additionalPaymentType.label
            }}</mat-option>
          }
        </mat-select>
        @if (form.get('description')?.invalid) {
        <mat-error>{{
          appService.getErrorMessage(form.get('description'))
          }}</mat-error>
        }
      </mat-form-field>
    </div>
    }
  </div>
  @if (
  (form.get('amount')?.value || 0) > pendingAmount() &&
  !ticketNumber() &&
  type() === 'regularPayment'
  ) {
  @if (pendingAmount() === 0) {
  <div class="d-flex align-items-center gap-2 ft-card ft-card--danger gap-2 mt-3 p-2 lh-sm" style="font-size: 0.75rem">
    <ft-icon name="error" class="ft-icon--2 text-danger" />
        <div i18n>You cannot register a payment from this option because the loan has no overdue amounts. Go to the "Payment" option to register the payment as a principal payment.</div>
  </div>
  } @else if ((form.get('amount')?.value || 0) > pendingAmount()) {
  <div class="d-flex align-items-center gap-2 ft-card ft-card--danger gap-2 mt-3 p-2 lh-sm" style="font-size: 0.75rem">
    <ft-icon name="error" class="ft-icon--2 text-danger" />
        <div i18n>You're registering a payment that exceeds the amount currently owed. In this option, you can record a payment up to the maximum amount shown above, and any excess can be applied using the "Reduce term/payment" option.</div>
  </div>
  }
  }
  @if (type() === 'additionalPayment' && !ticketNumber()) {
  <div class="d-flex align-items-center gap-2 ft-card ft-card--info gap-2 mt-3 p-2 lh-sm" style="font-size: 0.75rem">
    <ft-icon name="information" class="ft-icon--2 text-info" />
    <div i18n><p>You can register a payment greater than the amount owed, and we will adjust the installment table according to the selected option.</p><p>It must be less than <strong>{{ totalAmount() | number }} {{ currencyId() }}</strong>. Otherwise, you must make a prepayment.</p></div>
  </div>
  }
  @if (type() === 'prePayment' && !ticketNumber()) {
  <div class="d-flex align-items-center gap-2 ft-card ft-card--info gap-2 mt-3 p-2 lh-sm" style="font-size: 0.75rem">
    <ft-icon name="information" class="ft-icon--2 text-info" />
      <div i18n>This option records the full payment and removes the loan from the active list.</div>
  </div>
  }
  <div style="
      opacity: 0;
      position: absolute;
      pointer-events: none;
      height: 0;
      overflow: hidden;
    ">
    <div #paymentElement class="ft-payment ft-content--finished ft-sharing-container">
      <div class="ft-card mb-3">
        <div class="ft-card__body text-center">
          <div>
            <div class="ft-icon ft-icon--lead ft-icon--3">
              <svg viewBox="0 0 24 24" style="
                  width: 1em;
                  height: 1em;
                  vertical-align: middle;
                  fill: currentColor;
                  display: inline-block;
                  font-size: 2rem;
                ">
                <path stroke="currentColor" stroke-width="2" d="M19.5 6.5l-10 10-5-5" fill="none"></path>
              </svg>
            </div>
          </div>
          <div class="ft-data-field">
            <div class="ft-data-field__value" style="
                font-size: var(--ft-display-font-size-lg);
                margin-top: 1rem;
              ">
              {{ form.get('amount')?.value | number }}
              <span class="ft-suffix ft-suffix--sm">{{ currencyId() }}</span>
            </div>
            <div class="ft-data-field__label" i18n>Amount paid</div>
          </div>
          <div class="mt-4 fs-6 text-success" i18n>Payment registered successfully</div>
          <div class="ft-info">
            <hr class="my-3" />
            <div class="ft-grid ft-grid--c-2">
              <div class="ft-data-field">
                <div class="ft-data-field__value">{{ ticketNumber() }}</div>
                <div class="ft-data-field__label" i18n>Receipt #</div>
              </div>
              <div class="ft-data-field">
                <div class="ft-data-field__value">
                  {{ form.get('paymentDate')?.value | date: 'dd/MM/yyyy' }}
                </div>
                <div class="ft-data-field__label" i18n>Date</div>
              </div>
            </div>
          </div>
        </div>
        <div class="ft-payment__brand">
          <img src="images/logo-meprestas.svg" alt="Logo MePrestas" />
        </div>
      </div>
    </div>
  </div>
  <div class="ft-observe-interseting" (ftObserveIntersecting)="
      appService.setOverlapped($event, actionsElement)
    "></div>
</form>
<div #actionsElement mat-dialog-actions>
  <div class="ft-actions__stepper">
    <div [ngStyle]="{ 'margin-top': ticketNumber() ? '-40px' : null }">
      @if (type() === 'prePayment' && !prePaymentCalculate()) {
      <div class="ft-actions__group">
        <button type="button" mat-stroked-button mat-dialog-close [disabled]="submitting()" i18n>Cancel</button>
        <button type="button" form="form" mat-flat-button color="primary" [disabled]="submitting()"
          (click)="calcPrePayment()">
          @if (!submitting()) {
          <span i18n>Calculate</span>
          } @else {
          <ng-container *ngTemplateOutlet="submittingTemplate"></ng-container>
          }
        </button>
      </div>
      }
      <div class="ft-actions__group">
        <button type="button" mat-stroked-button mat-dialog-close [disabled]="submitting()" i18n>Cancel</button>
        <button type="submit" form="form" mat-flat-button color="primary" [disabled]="
            submitting() ||
            ((form.get('amount')?.value || 0) > pendingAmount() &&
              type() === 'regularPayment')
          ">
          @if (!submitting()) {
          <span i18n>Save</span>
          } @else {
          <ng-container *ngTemplateOutlet="submittingTemplate"></ng-container>
          }
        </button>
      </div>
      <div class="ft-actions__group">
        @if (allowSharing()) {
        <button type="button" mat-stroked-button (click)="share()">
          @if (!sharing()) {
          <div class="ft-item gap-2">
            <ft-icon name="share" class="ft-icon--2" />
            <div i18n>Share</div>
          </div>
          } @else {
          <ng-container *ngTemplateOutlet="submittingTemplate"></ng-container>
          }
        </button>
        } @else {
        <button type="button" mat-stroked-button (click)="share(true)">
          @if (!sharing()) {
          <div class="ft-item gap-2">
            <ft-icon name="download" class="ft-icon--2" />
            <div i18n>Download</div>
          </div>
          } @else {
          <ng-container *ngTemplateOutlet="submittingTemplate"></ng-container>
          }
        </button>
        }
        <button type="button" mat-stroked-button mat-dialog-close i18n>Close</button>
      </div>
    </div>
  </div>
</div>
<ng-template #submittingTemplate>
  <div class="text-center">
    <ft-progress class="ft-progress--2"></ft-progress>
  </div>
</ng-template>